import { Component } from '@angular/core';

@Component({
  selector: 'prox-program-kit-info-sub',
  standalone: false,
  templateUrl: './program-kit-info.sub.component.html',
})
export class ProgramKitInfoSubComponent {}
